import axios from "axios";
import authHeader from "@/services/auth-header";
import ConstApiUrls from "@/services/const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL_UMKM

class FUmkmFileService {
  getApiUrl() {
    return API_URL;
  }
  getAllFUmkmFile() {
    return axios.get(API_URL + `getAllFUmkmFile`, { headers: authHeader() });
  }
  getAllFUmkmFileContaining(page, pageSize, sortBy, order, search) {
    return axios.get(
      API_URL +
        `getAllFUmkmFileContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`,
      { headers: authHeader() }
    );
  }
  getFUmkmFileById(id) {
    return axios.get(API_URL + `getFUmkmFileById/${id}`, {
      headers: authHeader(),
    });
  }
  getAllFUmkmFileByParent(id) {
    return axios.get(API_URL + `getAllFUmkmFileByParent/${id}`, {
      headers: authHeader(),
    });
  }
  getAllFUmkmFileByParentPublic(id) {
    return axios.get(API_URL + `public/getAllFUmkmFileByParent/${id}`, {
      headers: authHeader(),
    });
  }

  updateFUmkmFile(item) {
    return axios.put(API_URL + `updateFUmkmFile/${item.id}`, item, {
      headers: authHeader(),
    });
  }
  createFUmkmFile(item) {
    return axios.post(API_URL + `createFUmkmFile`, item, {
      headers: authHeader(),
    });
  }
  deleteFUmkmFile(id) {
    return axios.delete(API_URL + `deleteFUmkmFile/${id}`, {
      headers: authHeader(),
    });
  }

  deleteFUmkmFileAvatarByParent(fkegiatanBean) {
    return axios.delete(
      API_URL + `deleteFUmkmFileAvatarByParent/${fkegiatanBean}`,
      {
        headers: authHeader(),
      }
    );
  }
  createFUmkmFileAvatar(item) {
    return axios.post(API_URL + `createFUmkmFileAvatar`, item, {
      headers: authHeader(),
    });
  }

  deleteAllFUmkmFile(itemIds) {
    return axios.delete(API_URL + `deleteAllFUmkmFile`, {
      headers: authHeader(),
      data: itemIds,
    });
  }
}
export default new FUmkmFileService();
